import useTheme from '@/theme/useTheme';
import {
  Accordion,
  Typography,
  Chip,
  Box,
} from '@mui/material';

import { useTranslation } from 'next-i18next';
import React from 'react';
import HowItWorks from '@/components/ui/HowItWorks';
import step1Img from '/public/assets/images/casino/draw/draw-work-step-1.png'
import step2Img from '/public/assets/images/casino/draw/draw-work-step-2.png'
import step3Img from '/public/assets/images/casino/draw/draw-work-step-3.png'
import step4Img from '/public/assets/images/casino/draw/draw-work-step-4.png'

const MoonDrawIntro: React.FC = () => {
  const [t] = useTranslation();
  const { theme } = useTheme();

  const howItWorksSteps = [
    {
      text: t(`Enter the game by betting $0.52 USDT.`),
      imageSrc: step1Img.src
    },
    {
      text: t(`The game will start spinning once you hit the “Open for $0,52” button.`),
      imageSrc: step2Img.src
    },
    {
      text: t(`You can view the prizes and odds under the “Available Prizes” section.`),
      imageSrc: step3Img.src
    },
    {
      text: t(`You will win the prize that stops under the pointer.`),
      imageSrc: step4Img.src
    },
  ]
  return (
    <Accordion
      sx={{
        border: theme.palette.border.normal,
        borderRadius: '12px',
        marginTop: theme.spacing(2),
      }}
    >
      <Box
        sx={{ padding: theme.spacing(2),display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography>
          {t('moon-draw::Moon Draw')}&nbsp;
          <Typography
            component={'span'}
            sx={{
              fontSize: '12px',
              border: (theme) => theme.palette.border.primary,
              borderRadius: '8px',
              padding: '4px 8px',
              ml: '10px',
            }}
          >
            {t('MoonClub Originals')}
          </Typography>
        </Typography>
          
        <HowItWorks steps={howItWorksSteps} />
      </Box>
    </Accordion>
  );
};

export default MoonDrawIntro;
